import EditIcon from '@mui/icons-material/Edit';

export default EditIcon;
